//CDMSDateCellValidator - extends CellValidator

// validates date cells.

import * as moment from 'moment';
import {CellValidator, ValidationError} from "../cell-validation";

export function CDMSDateCellValidator(cdms_field) {
    this.base = CellValidator;
    this.base(cdms_field);
}
CDMSDateCellValidator.prototype = new CellValidator;

CDMSDateCellValidator.prototype.validateFieldControlTypeValidation = function (data, duplicateCheckEnabled, duplicateCheckFields) {
    // when checking for duplicate, display a fied error if a key field is blank
    if ((data.value == null || data.value == "") && duplicateCheckEnabled && duplicateCheckFields.includes(data.colDef.cdmsField.DbColumnName)
          && !this.validation.includes("required")) {
      return this.errors.push(new ValidationError(this.cdms_field, "Duplicate Checking field cannot be blank."));
    }

    if (data.value == null || data.value == "")
        return;

    //console.log("validating: " + data.value + " as a date.");

    if (!isValidDate(data.value))
        this.errors.push(new ValidationError(this.cdms_field, "Value is not a date (mm/dd/yyyy)."));

    return this.errors;
};

function isValidDate(dateString: string): boolean {
  const date = new Date(dateString);
  const year = date.getFullYear();
  // Check if the year is within a reasonable range (e.g., 1901 to 2100)
  if (year < 1901 || year > 2100) {
    return false;
  }
  return !isNaN(date.getTime());
}
